import React from 'react';

import CollectionSecondaryNavigationDesktop from 'components/CollectionSecondaryNavigationDesktop';
import CollectionSecondaryNavigationMobile from 'components/CollectionSecondaryNavigationMobile';
import { Small, Medium, LargeUp } from 'components/MediaQuery';

const CollectionSecondaryNavigation = ({ ...props }) => (
  <>
    <Small>
      <CollectionSecondaryNavigationMobile {...props} />
    </Small>
    <Medium>
      <CollectionSecondaryNavigationMobile {...props} />
    </Medium>
    <LargeUp>
      <CollectionSecondaryNavigationDesktop {...props} />
    </LargeUp>
  </>
);

CollectionSecondaryNavigation.propTypes = {};

export default CollectionSecondaryNavigation;
